<template>
  <div class="">
    <van-nav-bar
      title="发票信息编辑"
      left-text="返回"
      left-arrow
      @click-left="onClickLeft"
    />
    <van-form @submit="onSubmit">
      <van-field
        v-model="username"
        name="username"
        label="发票抬头"
        placeholder="请填写发票抬头"
        :rules="[{ required: true, message: '请填写发票抬头' }]"
      />
      <van-field
        v-model="duty"
        name="duty"
        label="税号"
        placeholder="请填写税号"
        :rules="[{ required: true, message: '请填写税号' }]"
      />
      <van-field
        readonly
        clickable
        name="type"
        :value="types"
        label="纳税人类型"
        placeholder="点击选择类型"
        @click="showPicker3 = true"
        :rules="[{ required: true, message: '请选择类型' }]"
      />
      <van-popup
        v-model="showPicker3"
        position="bottom"
      >
        <van-picker
          show-toolbar
          :columns='tlist'
          value-key="1"
          @confirm="onConfirm3"
          @cancel="showPicker3 = false"
        />
      </van-popup>
      <van-field
        v-model="address"
        name="address"
        label="邮寄地址"
        placeholder="请填写邮寄地址"
        :rules="[{ required: true, message: '请填写邮寄地址' }]"
      />
      <van-field
        v-model="addressee"
        name="addressee"
        label="收件人"
        placeholder="请填写收件人"
        :rules="[{ required: true, message: '请填写收件人' }]"
      />
      <van-field
        v-model="mobile"
        name="mobile"
        label="收件人电话"
        placeholder="请填写收件人电话"
        :rules="[{ required: true, message: '请填写收件人电话' }]"
      />
      <div style="margin: 16px;">
        <van-button
          round
          block
          type="info"
          native-type="submit"
        >
          提交
        </van-button>
      </div>
    </van-form>
  </div>
</template>
<script>
import Vue from 'vue'
import {
  NavBar,
  Button,
  Uploader,
  Field,
  Form,
  Checkbox,
  CheckboxGroup,
  Toast,
  Picker,
  Popup,
  Area
} from 'vant'
Vue.use(NavBar)
  .use(Field)
  .use(Button)
  .use(Uploader)
  .use(Form)
  .use(Checkbox)
  .use(CheckboxGroup)
  .use(Toast).use(Picker).use(Popup).use(Area)
export default {
  created () {
    if (this.$route.params.info) {
      this.username = this.$route.params.info.username
      this.addressee = this.$route.params.info.addressee
      this.duty = this.$route.params.info.duty
      this.mobile = this.$route.params.info.mobile
      this.types = this.$route.params.info.type
      this.address = this.$route.params.info.address
    }

  },
  data () {
    return {

      username: '',
      addressee: "",
      address: "",
      duty: "",
      mobile: '',
      types: "",
      showPicker3: false,
      tlist: ["个人经营定税", "小规模纳税人", "一般纳税人"],

    };
  },
  methods: {
    onClickLeft () {
      this.$router.go(-1)
    },
    onConfirm3 (value, i) {
      this.types = value;
      this.showPicker3 = false;
    },
    onSubmit (v) {
      if (this.$route.params.info) {
        v.id = this.$route.params.info.id
        // return false
        this.axios.post('edit_bill', { ...v, store_id: this.$store.state.shopid, }).then(res => {
          Toast(res.data.msg)
          this.$router.go(-1)
        }).catch(ref => { })
      } else {
        this.axios.post('add_bill', { ...v, store_id: this.$store.state.shopid, }).then(res => {
          Toast(res.data.msg)
          this.$router.go(-1)
        }).catch(ref => { })
      }

    }
  }
}
</script>
<style lang="less"  >
.van-switch {
  .van-switch__node {
    width: 0.65rem;
    height: 0.65rem;
  }
}
.van-switch--on .van-switch__node {
  transform: translateX(0.6rem);
}
</style>
